type CategoryFormattable = {
  category: string | null;
  thesisType?: string | null;
};

export const THESIS_TYPE_LABELS: Record<string, string> = {
  ESSAY: "Undergraduate Essay",
  HONOURS: "Honours Thesis",
  MASTERS: "Masters Thesis",
  PHD: "PhD Thesis",
};

export function formatCategory(app: CategoryFormattable): string {
  if (!app.category) return "-";
  if (app.category === "THESIS" && app.thesisType) {
    return THESIS_TYPE_LABELS[app.thesisType] ?? "Thesis";
  }
  if (app.category === "ARTIST") return "Visual Art";
  if (app.category === "WRITER") return "Writing";
  return (
    app.category.charAt(0).toUpperCase() + app.category.slice(1).toLowerCase()
  );
}
